import React, { useState, useEffect } from "react";
import "../../../components/Styles/FormStyle.css";
import "../../../components/Styles/SecondPage.css";
import { secret } from "../data";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactPlayer from "react-player";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const MySwal = withReactContent(Swal2);

const SecondDetailPage = (props) => {
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [mail, setMail] = useState("");
  const [expectations, setExpectations] = useState("Cena");
  const [region, setRegion] = useState("Mazowieckie");
  const [noContact, setNoContact] = useState(true);
  const [policy, setPolicy] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const regionList = [
    "Dolnośląskie",
    "Kujawsko-Pomorskie",
    "Lubelskie",
    "Lubuskie",
    "Łódzkie",
    "Małopolskie",
    "Mazowieckie",
    "Opolskie",
    "Podkarpackie",
    "Podlaskie",
    "Pomorskie",
    "Śląskie",
    "Świętokrzyskie",
    "Warmińsko-Mazurskie",
    "Wielkopolskie",
    "Zachodniopomorskie",
  ];

  const expectationList = [
    {
      value: "Ilość wygranych spraw",
      label: "doświadczenie kancelarii wyrażone w ilości wygranych spraw",
    },
    {
      value: "Lokalizacja",
      label: "biuro kancelarii znajdujące się w mojej okolicy",
    },
    { value: "Cena", label: "najniższa cena usługi prawnej" },
  ];

  const generateCode = () => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < 5) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  };

  const sendSMSCode = async (code) => {
    var body = {
      phone: phone,
      message: `Wprowadź kod: ${code} by dokończyć generowanie analizy Twojego zobowiązania.`,
    };

    await fetch("https://api.twojeskd.pl/send_sms_tskd", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secret,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {})
      .catch((error) => {});
  };

  const submitSecondStep = () => {
    if (policy && name && mail && phone) {
      var code = generateCode();
      sendSMSCode(code);
      MySwal.fire({
        title: "UWAGA",
        input: "text",
        inputLabel: "wprowadź kod otrzymany w SMS",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        confirmButtonText: "Pokaż kancelarie i wyniki analizy",
        cancelButtonColor: "#131e3d",
        inputValidator: (value) => {
          if (value !== code) {
            return "wprowadzony kod jest nieprawidłowy";
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          var data = {
            userName: name,
            userPhone: phone,
            userMail: mail,
            userExpectations: expectations,
            userRegion: region,
            noContact: noContact,
          };
          props.goToThirdPage(data);
        }
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd!",
        text: "uzupełnij wymagane pola formularza",
      }).then((result) => {});
    }
  };

  const destkop = (
    <>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "right",

            alignItems: "center",
          }}
        >
          <div style={{ width: "100%" }}>
            <p style={{ margin: "0", fontSize: "1vw" }}>
              Aby zobaczyć dane kancelarii oraz wyniki analizy Twojego
              zobowiąania uzupełnij dane kontaktowe. W najbliższych dniach
              postaramy się z Tobą skontaktować.
            </p>
          </div>
          <div
            style={{
              width: "20%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "right",
            }}
          ></div>
        </div>
        <div style={{ marginTop: "20px", display: "flex" }}>
          <div style={{ width: "50%", padding: "0px 10px 20px 0px" }}>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    textTransform: "uppercase",
                  }}
                >
                  1. imię i nazwisko *
                </p>
                <input
                  type="text"
                  style={{ width: "100%", boxSizing: "border-box" }}
                  name="creditAmmount"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    textTransform: "uppercase",
                  }}
                >
                  2. adres e-mail *
                </p>
                <input
                  type="text"
                  style={{ width: "100%", boxSizing: "border-box" }}
                  name="creditAmmount"
                  value={mail}
                  onChange={(e) => {
                    setMail(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    textTransform: "uppercase",
                  }}
                >
                  3. numer telefonu *
                </p>
                <input
                  type="text"
                  style={{ width: "100%", boxSizing: "border-box" }}
                  name="creditAmmount"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    textTransform: "uppercase",
                  }}
                >
                  4. w jakim województwie mieszkasz
                </p>
                <select
                  type="text"
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    backgroundColor: "transparent",
                    borderRadius: "5px",
                    height: "4vh",
                    borderColor: "#505a53",
                  }}
                  value={region}
                  onChange={(e) => {
                    setRegion(e.target.value);
                  }}
                >
                  {regionList.map((el) => (
                    <option key={el} value={el}>
                      {el}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    textTransform: "uppercase",
                  }}
                >
                  5. czego oczekujesz od kancelarii prawnej
                </p>
                <select
                  type="text"
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    backgroundColor: "transparent",
                    borderRadius: "5px",
                    height: "4vh",
                    borderColor: "#505a53",
                  }}
                  name="creditAmmount"
                  value={expectations}
                  onChange={(e) => {
                    setExpectations(e.target.value);
                  }}
                >
                  {expectationList.map((el) => (
                    <option key={el.value} value={el.value}>
                      {el.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <label className="containerPrivacyBox">
                  Oświadczam, że zapoznałem się z{" "}
                  <a
                    className="linkHref"
                    href="https://twojeskd.pl/polityka-prywatnosci/"
                    target="_blank"
                  >
                    Polityką prywatności
                  </a>{" "}
                  oraz akceptuje jej postanowienia i wyrażam zgodę na kontakt
                  kancelarii w niej wymienionych.
                  <span className="requiredStar">*</span>
                  <input
                    type="checkbox"
                    checked={policy}
                    onClick={() => {
                      setPolicy(!policy);
                    }}
                  />
                  <span className="checkmarkPrivacyBox"></span>
                </label>
              </div>
              <div style={{ width: "100%", padding: "20px 0px" }}>
                <p
                  style={{
                    fontWeight: "900",
                    color: "lightgray",
                    margin: "0",
                    fontSize: "10px",
                  }}
                >
                  Uwaga! Pamiętaj, że konsultacja z naszym specjalistą,
                  wygenerowanie analizy Twojego zobowiązania oraz rekomendacja
                  kancelarii są{" "}
                  <span style={{ color: "red", opacity: ".3" }}>
                    całkowicie bezpłatne
                  </span>
                  .
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "20px",
                  display: "none",
                }}
              >
                <div style={{ width: "50%" }}>
                  <button
                    className="submitButtonFirstPage"
                    style={{
                      minWidth: "auto",
                      marginTop: "10px",
                      fontSize: ".7vw",
                      padding: "5px",
                      color: "white",
                      height: "5vh",
                      width: "100%",
                      backgroundColor: noContact
                        ? "orange"
                        : "rgb(116, 164, 188)",
                    }}
                    onClick={() => {
                      setNoContact(true);
                    }}
                  >
                    proszę o reomendację kancelarii prawnych, nie potrzebuje
                    konsultacji z specjalistą
                  </button>
                </div>
                <div style={{ width: "50%" }}>
                  <button
                    className="submitButtonFirstPage"
                    style={{
                      minWidth: "auto",
                      marginTop: "10px",
                      fontSize: ".7vw",
                      padding: "5px",
                      color: "white",
                      height: "5vh",
                      width: "100%",
                      backgroundColor: !noContact
                        ? "orange"
                        : "rgb(116, 164, 188)",
                    }}
                    onClick={() => {
                      setNoContact(false);
                    }}
                  >
                    proszę o kontakt specjalisty przed rekomendacją kancelarii
                    prawnych
                  </button>
                </div>
              </div>
              <div style={{ width: "100%", alignSelf: "flex-end" }}>
                <button
                  className="submitButtonFirstPage"
                  onClick={submitSecondStep}
                  style={{
                    fontSize: "1vw",
                    fontWeight: "600",
                    width: "100%",
                    marginTop: "1vh",
                  }}
                >
                  DALEJ
                </button>
              </div>
            </div>
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "flex-end",
              alignContent: "flex-start",
              flexWrap: "wrap",
              padding: "20px",
            }}
          >
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "left",
                flexWrap: "wrap",
              }}
            >
              <p
                style={{
                  margin: "0",
                  paddingBottom: "10px",
                  fontWeight: "600",
                  fontSize: ".8vw",
                  textTransform: "uppercase",
                  width: "100%",
                }}
              >
                Taki widok zobaczysz po przejściu dalej
              </p>
              <div>
                <ReactPlayer
                  width="100%"
                  height="100%"
                  loop={true}
                  url="https://ftpeople.pl/wp-content/uploads/2025/04/Nagranie-z-ekranu-2025-04-17-o-10.28.26-1.mp4"
                  playing={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const mobile = (
    <>
      <div style={{}}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "right",

            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "right",
              marginBottom: "10px",
            }}
          ></div>
        </div>
        <div
          style={{ marginTop: "10px", display: "flex", flexWrap: "wrap   " }}
        >
          <div style={{ width: "100%", padding: "0px 10px 10px 0px" }}>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: "3vw",
                    textTransform: "uppercase",
                  }}
                >
                  1. imię i nazwisko *
                </p>
                <input
                  type="text"
                  style={{ width: "100%", boxSizing: "border-box" }}
                  name="creditAmmount"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: "3vw",
                    textTransform: "uppercase",
                  }}
                >
                  2. adres e-mail *
                </p>
                <input
                  type="text"
                  style={{ width: "100%", boxSizing: "border-box" }}
                  name="creditAmmount"
                  value={mail}
                  onChange={(e) => {
                    setMail(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: "3vw",
                    textTransform: "uppercase",
                  }}
                >
                  3. numer telefonu *
                </p>
                <input
                  type="text"
                  style={{ width: "100%", boxSizing: "border-box" }}
                  name="creditAmmount"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: "3vw",
                    textTransform: "uppercase",
                  }}
                >
                  4. w jakim województwie mieszkasz
                </p>
                <select
                  type="text"
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    backgroundColor: "transparent",
                    borderRadius: "5px",
                    height: "4vh",
                    borderColor: "#505a53",
                  }}
                  value={region}
                  onChange={(e) => {
                    setRegion(e.target.value);
                  }}
                >
                  {regionList.map((el) => (
                    <option key={el} value={el}>
                      {el}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <p
                  style={{
                    margin: "0",
                    paddingBottom: "10px",
                    fontWeight: "600",
                    fontSize: "3vw",
                    textTransform: "uppercase",
                  }}
                >
                  5. czego oczekujesz od kancelarii prawnej
                </p>
                <select
                  type="text"
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    backgroundColor: "transparent",
                    borderRadius: "5px",
                    height: "4vh",
                    borderColor: "#505a53",
                  }}
                  name="creditAmmount"
                  value={expectations}
                  onChange={(e) => {
                    setExpectations(e.target.value);
                  }}
                >
                  {expectationList.map((el) => (
                    <option key={el.value} value={el.value}>
                      {el.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-end",
              alignContent: "flex-end",
              flexWrap: "wrap",
              padding: "0px",
            }}
          >
            <div style={{ width: "100%", padding: "0px 0px" }}>
              <p
                style={{
                  fontWeight: "900",
                  color: "lightgray",
                  margin: "0",
                  fontSize: "2vw",
                }}
              >
                Uwaga! Pamiętaj, że konsultacja z naszym specjalistą,
                wygenerowanie analizy Twojej umowy kredytu waloryzowanego do
                waluty obcej oraz rekomendacja kancelarii są{" "}
                <span style={{ color: "red", opacity: ".3" }}>
                  całkowicie bezpłatne
                </span>
                .
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "20px",
                display: "none",
              }}
            >
              <div style={{ width: "100%" }}>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "10px",
                    fontSize: "3vw",
                    padding: "5px",
                    color: "white",
                    height: "5vh",
                    width: "100%",
                    backgroundColor: noContact
                      ? "orange"
                      : "rgb(116, 164, 188)",
                  }}
                  onClick={() => {
                    setNoContact(true);
                  }}
                >
                  proszę o reomendację kancelarii prawnych, nie potrzebuje
                  konsultacji z specjalistą
                </button>
              </div>
              <div style={{ width: "100%" }}>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "0px",
                    fontSize: "3vw",
                    padding: "5px",
                    color: "white",
                    height: "5vh",
                    width: "100%",
                    backgroundColor: !noContact
                      ? "orange"
                      : "rgb(116, 164, 188)",
                  }}
                  onClick={() => {
                    setNoContact(false);
                  }}
                >
                  proszę o kontakt specjalisty przed rekomendacją kancelarii
                  prawnych
                </button>
              </div>
            </div>
            <div
              className="row"
              style={{
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="rowElem">
                <label
                  className="containerPrivacyBox"
                  style={{
                    fontSize: "2vw",
                    marginTop: "1vh",
                    marginBottom: "1vh",
                  }}
                >
                  Oświadczam, że zapoznałem się z{" "}
                  <a
                    className="linkHref"
                    href="https://porownywarkachf.pl/polityka-prywatnosci/"
                    target="_blank"
                  >
                    Polityką prywatności
                  </a>{" "}
                  oraz akceptuje jej postanowienia i wyrażam zgodę na kontakt
                  kancelarii w niej wymienionych.
                  <span className="requiredStar">*</span>
                  <input
                    type="checkbox"
                    checked={policy}
                    onClick={() => {
                      setPolicy(!policy);
                    }}
                  />
                  <span className="checkmarkPrivacyBox"></span>
                </label>
              </div>
            </div>
            <div style={{ width: "100%", alignSelf: "flex-end" }}>
              <button
                className="submitButtonFirstPage"
                onClick={submitSecondStep}
                style={{
                  fontSize: "3vw",
                  fontWeight: "600",
                  width: "100%",
                  marginTop: "1vh",
                }}
              >
                DALEJ
              </button>
            </div>
            <div
              className="row"
              style={{
                marginTop: "2vh",
                display: "flex",
                justifyContent: "left",
                flexWrap: "wrap",
              }}
            >
              <p
                style={{
                  margin: "0",
                  paddingBottom: "10px",
                  fontWeight: "600",
                  fontSize: "3vw",
                  textTransform: "uppercase",
                  width: "100%",
                }}
              >
                Taki widok zobaczysz po przejściu dalej
              </p>
              <div>
                <ReactPlayer
                  width="100%"
                  height="100%"
                  loop={true}
                  url="https://ftpeople.pl/wp-content/uploads/2025/04/Nagranie-z-ekranu-2025-04-17-o-10.28.26-1.mp4"
                  playing={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="destkopView">{destkop}</div>
      <div className="mobileView">{mobile}</div>
    </>
  );
};

export default SecondDetailPage;
